import { UNIT_SUFFIX } from "@/data/pricing";
import { formatDKK, exclMoms } from "@/lib/pricing";

const buildLabels = (it) => {
  const suffix = UNIT_SUFFIX[it.unit] ?? "";
  const prefix = it.unit === "genstand" ? "+" : "";
  const incl = `${it.isFrom ? "fra " : ""}${prefix}${formatDKK(it.value)} kr${suffix}`;
  const excl = `${prefix}${formatDKK(exclMoms(it.value), 2)} kr${suffix} ekskl.`;
  return { incl, excl };
};

const PriceTag = ({ it, onSelectPrice }) => {
  if (it.quote) {
    return (
      <button
        type="button"
        data-testid={`price-button-${it.id}`}
        onClick={() => onSelectPrice(it.name, "Individuelt tilbud", {})}
        className="flex w-44 shrink-0 items-center justify-center rounded-lg border border-[color:var(--rs-gold)]/50 px-3 py-3 text-center text-xs uppercase leading-tight tracking-widest text-[color:var(--rs-gold)] transition-colors duration-300 hover:bg-[color:var(--rs-gold)] hover:text-[#0A0A0A] sm:w-56"
      >
        Individuelt tilbud
      </button>
    );
  }
  const { incl, excl } = buildLabels(it);
  return (
    <button
      type="button"
      data-testid={`price-button-${it.id}`}
      onClick={() =>
        onSelectPrice(it.name, incl, { value: it.value, unit: it.unit, isFrom: !!it.isFrom })
      }
      className="flex w-44 shrink-0 flex-col items-center justify-center rounded-lg border border-[color:var(--rs-border)] bg-[color:var(--rs-panel2)] px-3 py-2.5 text-center transition-colors duration-300 hover:border-[color:var(--rs-gold)] sm:w-56"
    >
      <span className="whitespace-nowrap text-sm font-light leading-tight text-[color:var(--rs-gold)] sm:text-base">{incl}</span>
      <span className="mt-0.5 whitespace-nowrap text-[10px] text-[color:var(--rs-muted)]">{excl}</span>
    </button>
  );
};

export const PriceGroupList = ({ groups, onSelectPrice }) => (
  <div className="space-y-8">
    {groups.map((g) => (
      <div
        key={g.id}
        data-testid={`pricing-group-${g.id}`}
        className="rounded-2xl border border-[color:var(--rs-border)] bg-[color:var(--rs-panel)] p-6 sm:p-8"
      >
        <h3 className="font-heading text-2xl text-[color:var(--rs-text)]">{g.title}</h3>

        <div className="mt-6 space-y-3">
          {g.items.map((it) => (
            <div
              key={it.id}
              data-testid={`price-row-${it.id}`}
              className="flex items-start justify-between gap-4 rounded-xl border border-[color:var(--rs-border)] bg-[color:var(--rs-panel2)] p-4"
            >
              <div className="min-w-0">
                <p className="text-base text-[color:var(--rs-text)]">{it.name}</p>
                {it.sub && <p className="mt-0.5 text-xs text-[color:var(--rs-muted)]">{it.sub}</p>}
                {it.bullets && (
                  <ul className="mt-2 space-y-1">
                    {it.bullets.map((b, i) => (
                      <li key={i} className="flex gap-2 text-xs leading-relaxed text-[color:var(--rs-muted)]">
                        <span className="text-[color:var(--rs-gold)]">·</span>
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <PriceTag it={it} onSelectPrice={onSelectPrice} />
            </div>
          ))}
        </div>

        {g.note && (
          <p className="mt-5 border-t border-[color:var(--rs-border)] pt-4 text-xs leading-relaxed text-[color:var(--rs-muted)]">
            {g.note}
          </p>
        )}
      </div>
    ))}
  </div>
);
